import { render, staticRenderFns } from "./FeatureDisplayBody.vue?vue&type=template&id=19fd953a&scoped=true"
import script from "./FeatureDisplayBody.vue?vue&type=script&lang=js"
export * from "./FeatureDisplayBody.vue?vue&type=script&lang=js"
import style0 from "./FeatureDisplayBody.vue?vue&type=style&index=0&id=19fd953a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd953a",
  null
  
)

export default component.exports